export default __webpack_public_path__ + "static/media/LogoHotel.47ce89b9.png";